export default "__VITE_ASSET__CLMndA1S__"